import './CompanyLinkInfo.scss';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';

import { COMPANY_URLS } from '@/constants/urls';
import Company from '@/model/General/Company';

import CompanyContactInfoModal from './CompanyContactInfoModal';
import LinkTextField from './LinkTextField';

interface CompanyLinkInfoProps {
  company?: Company;
}

// Metadata: agrupa link a empresa y acceso al modal de contacto usado en varias vistas show.
const CompanyLinkInfo = (props: CompanyLinkInfoProps) => {
  const { company } = props;

  return (
    <Flex gap={4} className="CompanyLinkInfo">
      <LinkTextField
        label={company ? `${company?.full_name} (${company?.id})` : '-'}
        to={`${COMPANY_URLS.ADMIN_EMPRESA}/${company?.id}`}
        admin
      />
      {company && (
        <CompanyContactInfoModal
          company={new Company(company)}
          openButton={
            <Button
              className="CompanyLinkInfoButton"
              type="text"
              size="small"
              icon={<InfoCircleOutlined />}
            />
          }
        />
      )}
    </Flex>
  );
};

export default CompanyLinkInfo;
